import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { HtmlTag } from "../libs/helpers"

import * as styles from "./linklist.module.scss"

const LinkListItem = ({ page, label, href, image, text, theme }) => {
  const img = getImage(image?.localFile)
  const path = href || page.path
  const copy = label || page.title
  let tag = 'span'
  if (theme === 'cards') {
    tag = 'h2'
  }
  if (theme === 'home') {
    tag = 'h3'
  }
  return (
    <a href={path} className={styles['link']}>
      <div className={styles['linkInner']}>
        { img &&
        <div className={styles['image']}>
          <GatsbyImage image={img} alt={image?.alternativeText || 'alt'} />
        </div>
        }
        <HtmlTag tagName={tag} className={styles['title']}>
          {copy}
        </HtmlTag>
        { text &&
        <div className={styles['text']}>
          {text}
        </div>
        }
      </div>
    </a>
  )
}

const LinkList = ({ theme, linkListItems }) => {
  return (
    <section className={styles[theme]}>
      <div className={styles['inner']}>
        <div className={styles['links']}>
          {linkListItems.map((item, i) => <LinkListItem key={i} theme={theme} {...item} />)}
        </div>
      </div>
    </section>
  )
}

export default LinkList

export const query = graphql`
  fragment LinkListData on STRAPI__COMPONENT_COMPONENT_LINK_LIST {
    theme
    linkListItems {
      label
      href
      page {
        path
        title
      }
      text
      image {
        alternativeText
        localFile {
          childImageSharp {
            gatsbyImageData(height: 100 placeholder: BLURRED)
          }
        }
      }
    }
  }
`
